import { Station } from '@mi-front/core';

export function isDiarizationSegmentsEnabled(station: Station) {
  return (
    Boolean(station.featuresConfig?.transcription?.enabled) &&
    Boolean(station.featuresConfig?.transcription?.diarization?.segments)
  );
}
